module.exports = __webpack_public_path__ + "static/img/yytx13.aa4893d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/yytx13.png
// module id = 885
// module chunks = 0